import React from 'react';
import { TaxiCompanyList } from '../../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { useTranslation } from 'react-i18next';
import AMCCautionJP from './jp';
import AMCCautionEN from './en';

interface Props {
  /** 仮予約画面で表示するタクシー会社名 */
  companyDisplayName: string,
  /** タクシー会社 */
  company: TaxiCompanyList,
  /** 【AM-1152】マイル増量キャンペーン期間中か */
  isCampaignPeriod?: boolean,
  /** 【AM-1152】通常マイルあり（元々AMC ON）の会社か */
  isOriginalSupported?: boolean,
}

/** AMCマイレージ番号に関する注意事項 */
export const AMCCaution: React.FC<Props> = (props: Props) => {
  const { i18n } = useTranslation();
  switch(i18n.language) {
    case 'en':
      return (
        <AMCCautionEN
          companyDisplayName={props.companyDisplayName}
          company={props.company}
        />
      )
    case 'jp':
    default:
      return (
        <AMCCautionJP
          companyDisplayName={props.companyDisplayName}
          company={props.company}
          isCampaignPeriod={props.isCampaignPeriod}
          isOriginalSupported={props.isOriginalSupported}
        />
      )
  }
}
